import script from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FooterComponent.vue?vue&type=style&index=0&id=feddc89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feddc89e"]])

export default __exports__